import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION12: PdfComponent = {
  type: 'section',
  id: 's12',
  title: '12. Limitation of Liability',
  content: [
    {
      type: 'bulletList',
      id: 's12bullets',
      bulletType: 'number',
      content: [
        {
          copy: "The extent of the parties' Liability under or in connection with this Agreement (regardless of whether such Liability arises in tort, contract or in any other way and whether or not caused by negligence or misrepresentation) shall be as set out in this clause 12.",
        },
        {
          copy: "The parties agree that the limitations in this clause 12 are reasonable given each party's respective commercial positions and their ability to obtain insurance in respect of the risks arising under or in connection with this Agreement.",
        },
        {
          copy: 'Subject to clauses 12.5 and 12.6, the entire liability of Kanda to the Subscriber arising out of or in connection with this Agreement, whether arising from contract (including, without limitation, repudiatory breach of contract), tort, negligence or otherwise, shall be limited to direct losses, which shall not exceed £1,000.',
        },
        {
          copy: 'Except as otherwise provided in clauses 12.6 (Limitation of liability) and 22 (Indemnity), neither party shall be liable for any Liability that is indirect or consequential in nature.',
        },
        {
          copy: 'Subject to clause 12.6, neither party shall be liable for any of the following (whether direct or indirect):',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'loss of use;',
              },
              {
                copy: 'loss of production;',
              },
              {
                copy: 'loss of opportunity; and/or',
              },
              {
                copy: 'loss of savings, discount or rebate (whether actual or anticipated).',
              },
            ],
          },
        },
        {
          copy: 'Notwithstanding any other provision of this Agreement, nothing in this Agreement shall limit or exclude the liability of:',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'either party for death or personal injury caused by its negligence, or that of its employees, agents or subcontractors;',
              },
              {
                copy: 'either party for fraud or fraudulent misrepresentation;',
              },
              {
                copy: 'Kanda in respect of an obligation in this Agreement to indemnify any lender or other person in accordance with the terms of clause 21 (Indemnity);',
              },
              {
                copy: 'Kanda for any Liability caused by wilful misconduct;',
              },
              {
                copy: 'Kanda for any Liability caused by its wilful abandonment of this Agreement;',
              },
              {
                copy: 'the Subscriber for any breach of clause 15 (Confidential Information), clause 18 (Data Protection and Security) and/or clause 19 (Intellectual Property Rights); and/or',
              },
              {
                copy: 'either party for any other Liability which cannot be excluded or limited by Applicable Law.',
              },
            ],
          },
        },
      ],
      prefix: '12',
    },
  ],
};
